"use client"

import * as React from "react"

import { MobileFormSelectRow } from "@/shared/components/mobile-form"
import { useMemberLookupOptions } from "@/shared/components/member-async-select"

/**
 * Choosing a member in a phone form: a row that opens the app's picker sheet with server search (members are
 * too many to load), scoped the same way as the desktop member select.
 */
export function MobileMemberSelectRow({
  label,
  value,
  onChange,
  placeholder,
  searchPlaceholder,
  doneLabel,
  emptyLabel,
  clearLabel,
  targetBranchId,
  forceParishContext,
  selectedLabel,
  excludeIds,
  invalid,
  disabled,
}: {
  label: string
  value: string | undefined
  onChange: (value: string | undefined) => void
  placeholder: string
  searchPlaceholder?: string
  doneLabel: string
  emptyLabel: string
  clearLabel?: string
  targetBranchId?: string | null
  forceParishContext?: boolean
  /** The chosen member's name when it is already known (an edit), so the row never shows a raw id. */
  selectedLabel?: string
  excludeIds?: string[]
  invalid?: boolean
  disabled?: boolean
}) {
  const [query, setQuery] = React.useState("")
  const lookup = useMemberLookupOptions({
    query,
    targetBranchId,
    forceParishContext,
    selectedValue: value,
    selectedLabel,
    excludeIds,
    limit: 20,
  })
  const options = lookup.options.map((option) => ({ value: option.value, label: option.label }))
  return (
    <MobileFormSelectRow
      label={label}
      placeholder={placeholder}
      value={value}
      valueLabel={value ? options.find((option) => option.value === value)?.label ?? selectedLabel : undefined}
      onChange={(next) => onChange(next)}
      options={options}
      searchPlaceholder={searchPlaceholder ?? label}
      doneLabel={doneLabel}
      emptyLabel={emptyLabel}
      clearLabel={clearLabel}
      onQueryChange={setQuery}
      loading={lookup.isFetching}
      invalid={invalid}
      disabled={disabled}
    />
  )
}
